'use strict';

require('babel-polyfill');

module.exports = {
  app: {
    title: 'Kuna Internal Stats',
    description: 'Internal tools to troubleshoot and gather stats',
    head: {
      titleTemplate: 'Kuna internal stats: %s',
      meta: [{ name: 'description', content: 'Kuna internal stats' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'Kuna internal stats' }, {
        property: 'og:image',
        content: 'https://www.getkuna.com/wp-content/uploads/2016/04/logo@2x1.png'
      }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'Kuna internal stats' }, { property: 'og:description', content: 'Kuna internal stats' }, { property: 'og:card', content: 'summary' }, { property: 'og:site', content: '@sean9keenan' }, { property: 'og:creator', content: '@sean9keenan' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/client_config.js
 ** module id = 1375
 ** module chunks = 0
 **/